import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import actions from '../../../../actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ImitateEmployeePage from '../../../presenters/admins/ImitateEmployeePage/ImitateEmployeePage';
import * as UserType from '../../../../constants/UserType';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import { DEFAULT_ACTIVE_BRANCH_ID } from '../../../../constants/constants';
import { storeIsAuthenticated } from '../../../../utils/session-util';

const PAGINATION_SIZE = [50, 100, 200, 500];
const DEFAULT_PAGE_SIZE = 500;

class ImitateEmployeeContainer extends PureComponent {
  constructor(props) {
    super(props);

    const imitableEmployees = Object.values(UserType).filter(
      (userType) => userType.imitable
    );

    imitableEmployees.sort((a, b) => a.rank - b.rank);

    this.state = {
      imitableEmployees,
      selectedUserType: imitableEmployees.find((im) => im.name === 'GM').name,
      firstName: '',
      lastName: '',
      employees: [],
      loading: false,
      page: {
        size: DEFAULT_PAGE_SIZE,
        number: 0
      },
      sortBy: {
        name: 'branchCode',
        direction: 'asc'
      }
    };

    this.loadState = this.loadState.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeUserType = this.onChangeUserType.bind(this);
    this.onChangeFirstName = this.onChangeFirstName.bind(this);
    this.onChangeLastName = this.onChangeLastName.bind(this);
    this.onSelectEmployee = this.onSelectEmployee.bind(this);
    this.getSearchCriteria = this.getSearchCriteria.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  componentDidMount() {
    this.loadState();
  }

  loadState() {
    this.setState(
      {
        loading: true
      },
      () => {
        api.imitableEmployees
          .search(this.getSearchCriteria(), {
            page: this.state.page,
            sortBy: this.state.sortBy
          })
          .then((response) => {
            const employess = response.data.content;
            employess.forEach((employee) => {
              const matchingBranch = this.props.appStore.branches.find(
                (branch) => branch.branchId === employee.branchId
              );
              employee.branchDescription = !!matchingBranch
                ? matchingBranch.branchDesc
                : null;
            });

            this.setState({
              employees: response.data.content,
              loading: false,
              page: {
                size: response.data.size,
                totalElements: response.data.totalElements,
                number: response.data.number,
                numberOfElements: response.data.numberOfElements
              }
            });
          })
          .catch((err) => {
            console.error('error fetching employees: ', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  getSearchCriteria() {
    const firstName = !!this.state.firstName ? this.state.firstName : null;
    const lastName = !!this.state.lastName ? this.state.lastName : null;
    const branchIds =
      DEFAULT_ACTIVE_BRANCH_ID !== this.props.appStore.activeBranchId
        ? [
            this.props.appStore.branches.find(
              (branch) => branch.branchId === this.props.appStore.activeBranchId
            ).branchId
          ]
        : this.props.appStore.branches.map((branch) => branch.branchId);
    const role = !!this.state.selectedUserType
      ? this.state.selectedUserType
      : null;

    return {
      firstName,
      lastName,
      branchIds,
      role
    };
  }

  onSearch() {
    this.setState({
      page: {
        ...this.state.page,
        number: 0
      }
    });
    this.loadState();
  }

  onChangeUserType(selectedUserType) {
    this.setState({
      selectedUserType,
      page: {
        ...this.state.page,
        number: 0
      }
    });
  }

  onChangeFirstName(firstName) {
    this.setState({
      firstName,
      page: {
        ...this.state.page,
        number: 0
      }
    });
  }

  onChangeLastName(lastName) {
    this.setState({
      lastName,
      page: {
        ...this.state.page,
        number: 0
      }
    });
  }

  onSelectEmployee(employee) {
    this.setState(
      {
        loading: true
      },
      () => {
        api.imitableEmployees
          .getToken(employee.employeeId)
          .then((response) => {
            storeIsAuthenticated(response.data.token);
            window.location.reload();
          })
          .catch((err) => {
            console.error('error imitating employee', err.message);
            this.setState({
              loading: false
            });
          });
      }
    );
  }

  handleChangeRowsPerPage(rows) {
    this.setState(
      {
        page: {
          size: rows,
          numberOfElements: rows,
          totalElements: this.state.page.totalElements,
          number: 0
        }
      },
      this.loadState
    );
  }

  handleChangePage(number) {
    this.setState(
      {
        page: {
          ...this.state.page,
          number
        }
      },
      this.loadState
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <ImitateEmployeePage
        onSearch={this.onSearch}
        userTypes={this.state.imitableEmployees}
        selectedUserType={this.state.selectedUserType}
        onChangeUserType={this.onChangeUserType}
        firstName={this.state.firstName}
        onChangeFirstName={this.onChangeFirstName}
        lastName={this.state.lastName}
        onChangeLastName={this.onChangeLastName}
        employees={this.state.employees}
        onSelectEmployee={this.onSelectEmployee}
        page={this.state.page}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        handleChangePage={this.handleChangePage}
        rowsPerPageOptions={PAGINATION_SIZE}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ImitateEmployeeContainer)
);
